const t = (e) => e, n = t({
  default: {
    ease: "easeInOut",
    duration: 0.15
  },
  defaultSlow: {
    ease: "easeInOut",
    duration: 0.4
  },
  spring: {
    type: "spring",
    duration: 0.4,
    bounce: 0.3
  }
}), a = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  transitions: n
}, Symbol.toStringTag, { value: "Module" }));
export {
  n as a,
  a as t
};
